import { useState } from 'react';

import VIDEO_TUTORIALS_MODAL_MODE from '@/enums/videoTutorialsModalMode';
import { useDemoContext } from '@/hooks/DemoContext';
import getVideoTutorials from '@/utils/functions/getVideoTutorials/getVideoTutorials';
import trackTutorialPlay from '@/utils/functions/trackTutorialPlay/trackTutorialPlay';

import type { OperationKey, TutorielOperation, TutorielVideo, VideoTutorialsModalEntry } from '@/types/videoTutorials';

interface UseContractTutorialsParams {
  link: string | null | undefined;
  operation?: OperationKey | TutorielOperation;
  onPartnerAccess: () => void;
}

const useContractTutorials = ({ link, operation, onPartnerAccess }: UseContractTutorialsParams) => {
  const { isDemo } = useDemoContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(VIDEO_TUTORIALS_MODAL_MODE.ALL);

  const { catalogKey, tutorials, operationTutorial } = getVideoTutorials(link, operation);
  const partnerName = catalogKey ?? '';
  const modalEntry: VideoTutorialsModalEntry =
    modalMode === VIDEO_TUTORIALS_MODAL_MODE.SINGLE && operationTutorial
      ? { mode: VIDEO_TUTORIALS_MODAL_MODE.SINGLE, tutorial: operationTutorial }
      : { mode: VIDEO_TUTORIALS_MODAL_MODE.ALL, tutorials };

  const openOperationTutorial = () => {
    setModalMode(VIDEO_TUTORIALS_MODAL_MODE.SINGLE);
    setIsModalOpen(true);
  };

  const openAllTutorials = () => {
    setModalMode(VIDEO_TUTORIALS_MODAL_MODE.ALL);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handlePlay = (tutorial: TutorielVideo) => {
    if (isDemo) return;
    trackTutorialPlay(partnerName, tutorial);
  };

  // La modale de tuto passe au-dessus de tout : la fermer avant, sinon elle masquerait la popin KYC de l'écran.
  const handlePartnerAccess = () => {
    closeModal();
    onPartnerAccess();
  };

  return {
    tutorials,
    operationTutorial,
    partnerName,
    link,
    isDemo,
    isModalOpen,
    modalEntry,
    showOperationTutorial: !!operation && !!operationTutorial,
    showWatchTutorials: !operation && tutorials.length > 0,
    openOperationTutorial,
    openAllTutorials,
    closeModal,
    handlePlay,
    handlePartnerAccess,
  };
};

export default useContractTutorials;
